var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNoview(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    stroke: "#AFAFAF",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M2.8 3L16.8 17",
    transform: "translate(-135 -363) translate(135 363)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.6 10L6.09 8.51c-.188.474-.286.98-.29 1.49.016 2.313 1.887 4.184 4.2 4.2.51-.004 1.015-.103 1.49-.29L10 12.4c-1.314-.027-2.373-1.086-2.4-2.4zM10 7.6c1.319.016 2.384 1.081 2.4 2.4 0 .175-.02.35-.06.52l1.38 1.38c.31-.586.475-1.237.48-1.9-.016-2.313-1.887-4.184-4.2-4.2-.663.005-1.314.17-1.9.48l1.38 1.38c.17-.04.345-.06.52-.06z",
    transform: "translate(-135 -363) translate(135 363)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CECECE",
    fillRule: "nonzero",
    d: "M12.4 10c-.016-1.319-1.081-2.384-2.4-2.4-.175 0-.35.02-.52.06l2.86 2.86c.04-.17.06-.345.06-.52zM10 12.4L7.6 10c.027 1.314 1.086 2.373 2.4 2.4z",
    transform: "translate(-135 -363) translate(135 363)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CECECE",
    fillRule: "nonzero",
    d: "M20 10.1c-2.4-2.7-5.6-5.8-10-5.8-.917-.03-1.831.106-2.7.4 0 0-.23.07-.57.21L8.1 6.28c.586-.31 1.237-.475 1.9-.48 2.313.016 4.184 1.887 4.2 4.2-.005.663-.17 1.314-.48 1.9l2 2c1.606-1.049 3.048-2.33 4.28-3.8zM10 14.2c-2.313-.016-4.184-1.887-4.2-4.2.004-.51.102-1.016.29-1.49l-2-2C2.626 7.55 1.257 8.718 0 10l.5.5.5.5c2.6 2.6 5 4.7 9 4.7h.5c.799-.016 1.59-.164 2.34-.44l-1.35-1.35c-.475.187-.98.286-1.49.29z",
    transform: "translate(-135 -363) translate(135 363)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0H20V20H0z",
    transform: "translate(-135 -363) translate(135 363)"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoview);
export default __webpack_public_path__ + "static/media/noview.2ba01399.svg";
export { ForwardRef as ReactComponent };